import { render } from "./PatientSideEffects.vue?vue&type=template&id=ad823274"
import script from "./PatientSideEffects.vue?vue&type=script&lang=js"
export * from "./PatientSideEffects.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__